// Enum: haxe.io.Encoding

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

// Imports

var $estr = require("./../../estr_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Definition

var Encoding = $hxEnums["haxe.io.Encoding"] = { __ename__ : "haxe.io.Encoding", __constructs__ : ["UTF8","RawNative"]
  ,UTF8: {_hx_index:0,__enum__:"haxe.io.Encoding",toString:$estr}
  ,RawNative: {_hx_index:1,__enum__:"haxe.io.Encoding",toString:$estr}
};

exports.default = Encoding;